import { combineReducers } from 'redux';

import { reducers as configure } from './configure';
import { reducers as update } from './update';

export default combineReducers({
  configure,
  update,
});
